import React from "react";
import logo from "../../assets/images/icons/logoOfNoResult.svg";
interface LoaderProps {
  size?: "small" | "normal";
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = "normal", className = "" }) => {
  const sizeClasses = size === "normal" ? "w-12 h-12" : "w-6 h-6";

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className={`loader ${sizeClasses} ${className} animate-spin`}>
        <img src={logo} alt="Loader" />
      </div>
    </div>
  );
};

export default Loader;
